import { useEffect, useRef } from "react";

interface UseInfiniteScrollProps {
  onLoadMore: () => void;
  hasNextPage: boolean;
  isLoading: boolean;
  threshold?: number;
  trigger?: number;
}

export const useInfiniteScroll = ({
  onLoadMore,
  hasNextPage,
  isLoading,
  threshold = 200,
  trigger,
}: UseInfiniteScrollProps) => {
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const onLoadMoreRef = useRef(onLoadMore);

  useEffect(() => {
    onLoadMoreRef.current = onLoadMore;
  }, [onLoadMore]);

  useEffect(() => {
    const element = loadMoreRef.current;

    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasNextPage && !isLoading) {
          onLoadMoreRef.current();
        }
      },
      {
        rootMargin: `${threshold}px`,
      },
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [hasNextPage, isLoading, threshold, trigger]);

  return loadMoreRef;
};
